import { W_THRESH, type IncidentView } from "./incident-model.js";
import type { MonitoredRing } from "../../platform/monitored-places.js";

export interface WatchedZoneAlert { zoneName?: string; view: IncidentView; }

/** Fires at most one alert per (saved zone, incident subject) per app session, for
 *  CONFIRMED incidents only (W ≥ threshold). A saved-zone incident thus pings once
 *  and then lives in the "Other watched places" list — no escalation, no takeover.
 *  In-memory: a reload clears it (one re-alert possible, by design). */
export class WatchedZoneNotifier {
  #seen = new Set<string>();

  notify(entries: Array<{ view: IncidentView; ring: MonitoredRing }>): WatchedZoneAlert[] {
    const out: WatchedZoneAlert[] = [];
    for (const { view, ring } of entries) {
      if (view.W < W_THRESH) continue;
      const key = `${ring.cell}:${ring.radiusKm}:${view.subject}`;
      if (this.#seen.has(key)) continue;
      this.#seen.add(key);
      out.push({ zoneName: ring.placeName, view });
    }
    return out;
  }

  /** Clear the seen-set (identity erase / teardown). */
  reset(): void { this.#seen.clear(); }
}
